module.exports = __webpack_public_path__ + "static/fonts/dfyuanstd-w8.254726c.otf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/dfyuanstd-w8.otf
// module id = 0Kps
// module chunks = 1